import { useState } from 'react';
import { Button, Paper, Search } from '@safedns/skydns-ui-react-lib';

import './Collections.scss';

import CollectionsList from './CollectionsList';
import CollectionsEmptyCreate from './CollectionsEmptyCreate';
import FetchError from '../UI/fetch-error/FetchError';
import Loader from '../UI/loader/Loader';

import { useGetUserQuery, useGetCollectionsQuery } from '../../services/ADapi';

const Collections = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const {
    data: { user_id },
  } = useGetUserQuery();

  const {
    data: collections = [],
    isLoading,
    isError,
  } = useGetCollectionsQuery(user_id);

  const searchHandler = (e) => {
    setSearchQuery(e.target.value);
  };

  const clearField = () => {
    setSearchQuery('');
  };

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <FetchError />;
  }

  if (collections.length === 0) {
    return <CollectionsEmptyCreate />;
  }

  return (
    <Paper>
      <div className="collections-header-bar">
        <Search
          placeholder="Найти коллекцию"
          value={searchQuery}
          onChange={searchHandler}
          onClear={clearField}
          sx={{ maxWidth: 460, flex: '1 0' }}
        />
        <Button href="/collections/create" variant="primary">
          Добавить новую коллекцию
        </Button>
      </div>
      <CollectionsList searchQuery={searchQuery} />
    </Paper>
  );
};

export default Collections;
